import React from "react";

export default function Button({
  children,
  variant = "primary",
  className = "",
  ...props
}) {
  const base =
    "inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";
  const styles = {
  primary:
    "bg-blue-700 text-white hover:bg-blue-800 focus:ring-blue-700/30",
  secondary:
    "bg-white text-blue-700 border border-blue-700 hover:bg-blue-50 focus:ring-blue-700/20",
  ghost:
    "bg-transparent text-blue-700 hover:bg-blue-50 focus:ring-blue-700/20",
};


  return (
    <button className={`${base} ${styles[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}
